import { Modifier } from "@/dto/modifier";
import { ModifierGroup } from "@/dto/modifierGroup";
import { isEmpty } from "lodash";

export const buildFinalSelectedModifiers = (
  selectedModifiers: any,
  itemData: any
): Modifier[] => {
  if (!itemData?.modifierGroups || isEmpty(itemData.modifierGroups)) {
    return [];
  }

  return Object.keys(selectedModifiers).flatMap((groupId) => {
    const group: ModifierGroup = itemData.modifierGroups[groupId];
    const selections = selectedModifiers[groupId];
    return Object.keys(selections).map((modifierId) => {
      const modifier: Modifier | undefined = group?.modifiers?.find(
        (m: Modifier) => m.id === modifierId
      );
      return {
        name: modifier?.name,
        id: modifier?.id,
        price: modifier?.price,
        groupId: group.id,
        quantity: selections[modifierId],
      };
    });
  });
};

export const calculateModifiersTotal = (
  selectableModifierGroups: any,
  selectedModifiers: any
) => {
  let modifiersTotal = 0;
  selectableModifierGroups.forEach((group: any) => {
    const groupSelections = selectedModifiers[group.id];
    if (groupSelections) {
      Object.keys(groupSelections).forEach((modifierId) => {
        const modifier = group.modifiers.find(
          (m: Modifier) => m.id === modifierId
        );
        if (modifier) {
          modifiersTotal += modifier.price * groupSelections[modifierId];
        }
      });
    }
  });
  return modifiersTotal;
};

export const getMatchingModifiers = ({ modifiers, item }: any) => {
  return modifiers.filter((m: any) =>
    item.modifierGroupIds?.includes(m.groupId)
  );
};